import authService from '../components/api-authorization/AuthorizeService'
import EventAttendanceViewModel from '../models/attendance/GetEventAttendance/EventAttendanceViewModel';

export default class AttendanceController {
    async GetEventAttendance(eventId: string) : Promise<EventAttendanceViewModel | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('attendance/GetEventAttendees?eventId=' + eventId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` }
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }
}